export const cardiologyMatcherRegexp = /hypertension|high blood pressure/i

export const cancerMatcherRegexp = /cancer|lymphoma|leukemia|myeloma|tumor/i

export const dermatologyMatcherRegexp = /atopic dermatitis|psoriasis/i

export const gastroenterologyMatcherRegexp = /ulcerative colitis|obesity/i

export const metabolismAndEndocrinologyMatcherRegexp = /diabetes|obesity/i

export const neurologyMatcherRegexp =
  /alzheimer|cognitive|multiple sclerosis|sclerosis|epilepsy|myasthenia gravis/i

export const ophthalmologyMatcherRegexp = /stargardt|dry eye/i

export const orthopedicsMatcherRegexp = /osteoarthritis/i

export const psychiatryMatcherRegexp =
  /anxiety|generalized anxiety disorder|cognitive|schizophrenia|depressive|depression/i
export const depressionMatcherRegexp = /depressive|depression/i
export const socialAnxietyMatcherRegexp = /social anxiety/i
export const anxietyMatcherRegexp = /anxiety/i

export const respirologyMatcherRegexp = /asthma/i

export const rheumatologyMatcherRegexp = /arthritis/i
